export default "__VITE_ASSET__Djx_KLKh__"